import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { r1Api } from "../../services/api";
import type { PortfolioComment } from "../domain/types";

export function usePortfolioComments(
  fundId: number,
  quarter: string,
  enabled = false,
) {
  const queryClient = useQueryClient();
  const queryKey = ["r1", "portfolio-comments", fundId, quarter];

  const { data: comments = [], isLoading } = useQuery({
    queryKey,
    queryFn: () => r1Api.getPortfolioComments(fundId, quarter),
    staleTime: 30_000,
    enabled: enabled && !!fundId && !!quarter,
  });

  const { mutate: post, isPending: isPosting } = useMutation({
    mutationFn: (message: string) =>
      r1Api.createPortfolioComment({ fund_id: fundId, quarter, message }),
    onSuccess: (newComment: PortfolioComment) => {
      queryClient.setQueryData<PortfolioComment[]>(queryKey, (prev = []) => [
        ...prev,
        newComment,
      ]);
      queryClient.invalidateQueries({ queryKey: ["r1", "funds-portfolio"] });
      queryClient.invalidateQueries({ queryKey: ["r1", "tracker-row"] });
    },
  });

  return { comments, isLoading, post, isPosting };
}
